/* ====================================================================
   NATCHI — theme.js
   Cart drawer + AJAX cart, mobile menu, PDP gallery, accordions,
   variant selector, quantity steppers, sticky bar, collection tabs.
   Vanilla JS, no dependencies.
   ==================================================================== */
(function () {
  "use strict";

  var Natchi = window.Natchi || {};
  var routes = Natchi.routes || {};
  var money = Natchi.moneyFormat || "${{amount}}";

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(money.indexOf("no_decimals") > -1 ? 0 : 2);
    // Shopify money_format may use {{amount}} / {{amount_no_decimals}} etc.
    return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ================================================================
     CART DRAWER + AJAX
     ================================================================ */
  var drawer = {
    el: null, overlay: null,
    open: function () {
      if (this.overlay) this.overlay.classList.add("open");
      if (this.el) this.el.classList.add("open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      if (this.overlay) this.overlay.classList.remove("open");
      if (this.el) this.el.classList.remove("open");
      document.body.style.overflow = "";
    }
  };

  function refreshCart() {
    return fetch(routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        updateCount(cart.item_count);
        return cart;
      });
  }

  function updateCount(count) {
    $all("[data-cart-count]").forEach(function (n) {
      n.textContent = count;
      n.style.display = count > 0 ? "" : "none";
    });
  }

  function renderDrawer(cart) {
    var body = $("[data-drawer-body]");
    var foot = $("[data-drawer-foot]");
    var banner = $("[data-drawer-banner]");
    if (!body) return;
    var titleEl = $("[data-drawer-title]");
    if (titleEl) titleEl.textContent = "Your bag · " + cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="drawer-empty">Your bag is empty.</div>';
      if (foot) foot.style.display = "none";
      if (banner) banner.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "";

    // Free-shipping threshold (data attribute on drawer, default 6000 cents)
    var threshold = parseInt(drawer.el && drawer.el.getAttribute("data-free-threshold") || "0", 10);
    if (banner) {
      if (threshold > 0) {
        banner.style.display = "";
        if (cart.total_price >= threshold) {
          banner.style.background = "var(--color-off-white)";
          banner.style.color = "var(--color-black)";
          banner.textContent = "✓ You've unlocked free shipping";
        } else {
          banner.style.background = "var(--color-burgundy)";
          banner.style.color = "#fff";
          banner.textContent = "Add " + formatMoney(threshold - cart.total_price) + " for free shipping";
        }
      } else {
        banner.style.display = "none";
      }
    }

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, "_160x$1") : "";
      return '' +
        '<div class="drawer-line" data-key="' + it.key + '">' +
          '<div class="drawer-line-img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
          '<div class="drawer-line-info">' +
            '<div class="drawer-line-name">' + it.product_title + '</div>' +
            (it.variant_title ? '<div class="drawer-line-meta">' + it.variant_title + '</div>' : '') +
            '<div class="qty" data-line-qty>' +
              '<button data-qty-down aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="drawer-line-right">' +
            '<div class="drawer-line-price">' + formatMoney(it.final_line_price) + '</div>' +
            '<button class="drawer-line-remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }).join("");

    if (foot) {
      $all("[data-cart-subtotal]", foot).forEach(function (n) { n.textContent = formatMoney(cart.total_price); });
      var checkoutBtn = $("[data-checkout]", foot);
      if (checkoutBtn) checkoutBtn.textContent = "Checkout · " + formatMoney(cart.total_price);
    }
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      updateCount(cart.item_count);
      // reflect in a full cart page if present
      if (document.body.classList.contains("template-cart")) window.location.reload();
      return cart;
    });
  }

  function addToCart(form, openDrawer) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute("disabled", "disabled"); btn.dataset.label = btn.textContent; btn.textContent = "Adding…"; }
    var data = new FormData(form);
    return fetch(routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: data
    }).then(function (r) { return r.json(); }).then(function () {
      return refreshCart();
    }).then(function () {
      if (openDrawer) drawer.open();
    }).catch(function () {}).finally(function () {
      if (btn) { btn.removeAttribute("disabled"); btn.textContent = btn.dataset.label || "Add to bag"; }
    });
  }

  /* ================================================================
     INIT
     ================================================================ */
  document.addEventListener("DOMContentLoaded", function () {
    drawer.el = $("[data-cart-drawer]");
    drawer.overlay = $("[data-drawer-overlay]");

    // Open/close cart drawer
    $all("[data-open-cart]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); drawer.open(); refreshCart(); });
    });
    $all("[data-close-cart]").forEach(function (b) { b.addEventListener("click", drawer.close.bind(drawer)); });
    if (drawer.overlay) drawer.overlay.addEventListener("click", drawer.close.bind(drawer));
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") drawer.close(); });

    // Drawer line interactions (delegated)
    if (drawer.el) {
      drawer.el.addEventListener("click", function (e) {
        var line = e.target.closest("[data-key]");
        if (!line) return;
        var key = line.getAttribute("data-key");
        var qtyEl = line.querySelector("[data-line-qty] span");
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest("[data-remove]")) { changeLine(key, 0); }
        else if (e.target.closest("[data-qty-up]")) { changeLine(key, qty + 1); }
        else if (e.target.closest("[data-qty-down]")) { changeLine(key, Math.max(0, qty - 1)); }
      });
    }

    // AJAX add-to-cart forms
    $all("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCart(form, true);
      });
    });

    // Quick-add buttons (single variant) — data-add-variant="ID"
    $all("[data-quick-add]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = b.getAttribute("data-quick-add");
        if (!id) return;
        b.setAttribute("disabled", "disabled");
        var orig = b.textContent; b.textContent = "Adding…";
        fetch(routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        }).then(function () { return refreshCart(); }).then(function () {
          drawer.open();
        }).finally(function () { b.removeAttribute("disabled"); b.textContent = orig; });
      });
    });

    /* ---------- Mobile menu ---------- */
    var mm = $("[data-mobile-menu]");
    $all("[data-toggle-menu]").forEach(function (b) {
      b.addEventListener("click", function () { if (mm) mm.classList.toggle("open"); });
    });

    /* ---------- PDP gallery ---------- */
    $all("[data-gallery]").forEach(function (gal) {
      var track = $("[data-gallery-track]", gal);
      var mainTag = $("[data-gallery-tag]", gal);
      var pager = $("[data-gallery-pager]", gal);
      var thumbs = $all("[data-gallery-thumb]", gal);
      var slides = $all("[data-gallery-slide]", gal);
      if (!track || !slides.length) return;

      function pad(n) { return String(n).padStart(2, "0"); }
      var current = -1;

      function setActive(i) {
        if (i < 0 || i >= slides.length || i === current) return;
        current = i;
        var tag = slides[i].getAttribute("data-tag") || "";
        if (mainTag) { mainTag.textContent = tag; mainTag.style.display = tag ? "" : "none"; }
        if (pager) pager.textContent = pad(i + 1) + " / " + pad(slides.length);
        thumbs.forEach(function (t, j) { t.classList.toggle("is-active", j === i); });
        // Keep the active thumb visible when the strip scrolls (mobile), without moving the page.
        var active = thumbs[i];
        if (active) {
          var strip = active.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2, behavior: "smooth" });
          }
        }
      }

      // Tap a thumb -> slide the track to that image.
      thumbs.forEach(function (t, i) {
        t.addEventListener("click", function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
          setActive(i);
        });
      });

      // Swipe the track -> update thumb, counter and caption.
      var settle;
      track.addEventListener("scroll", function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          if (!track.clientWidth) return;
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 60);
      }, { passive: true });

      setActive(0);
    });

    /* ---------- Accordions (PDP + FAQ) ---------- */
    $all("[data-accordion]").forEach(function (acc) {
      $all("[data-acc-head]", acc).forEach(function (head) {
        head.addEventListener("click", function () {
          var item = head.closest("[data-acc-item]");
          var isOpen = item.classList.contains("is-open");
          if (acc.hasAttribute("data-acc-single")) {
            $all("[data-acc-item]", acc).forEach(function (x) { x.classList.remove("is-open"); });
          }
          item.classList.toggle("is-open", !isOpen);
          var toggle = head.querySelector("[data-acc-toggle]");
          if (toggle) toggle.textContent = item.classList.contains("is-open") ? "−" : "+";
        });
      });
    });

    /* ---------- Quantity steppers (PDP buy box) ---------- */
    $all("[data-qty-stepper]").forEach(function (st) {
      var input = $("input", st);
      var minus = $("[data-step-down]", st);
      var plus = $("[data-step-up]", st);
      var display = $("[data-step-display]", st);
      function get() { return parseInt((input && input.value) || (display && display.textContent) || "1", 10); }
      function set(v) { v = Math.max(1, v); if (input) input.value = v; if (display) display.textContent = v; }
      if (minus) minus.addEventListener("click", function () { set(get() - 1); });
      if (plus) plus.addEventListener("click", function () { set(get() + 1); });
    });

    /* ---------- Variant selector ---------- */
    $all("[data-variant-form]").forEach(function (form) {
      var data = $("[data-variant-json]", form);
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = $("[data-variant-id]", form);
      var priceEl = $("[data-variant-price]");
      var addBtn = $("[data-add-btn]", form);
      var selects = $all("[data-variant-option]", form);

      function currentVariant() {
        var chosen = selects.map(function (s) { return s.value; });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
      }
      function update() {
        var v = currentVariant();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (addBtn) {
          if (v.available) { addBtn.removeAttribute("disabled"); addBtn.querySelector("[data-add-label]") && (addBtn.querySelector("[data-add-label]").textContent = Natchi.strings.addToBag); }
          else { addBtn.setAttribute("disabled", "disabled"); addBtn.querySelector("[data-add-label]") && (addBtn.querySelector("[data-add-label]").textContent = Natchi.strings.soldOut); }
        }
      }
      selects.forEach(function (s) { s.addEventListener("change", update); });
      update();
    });

    /* ---------- Subscription / one-time toggle (visual placeholder) ---------- */
    $all("[data-mode-option]").forEach(function (opt) {
      opt.addEventListener("click", function () {
        var group = opt.closest("[data-mode-group]");
        $all("[data-mode-option]", group).forEach(function (x) { x.classList.remove("is-active"); });
        opt.classList.add("is-active");
        var sellingPlan = $("[data-selling-plan]");
        if (sellingPlan) sellingPlan.value = opt.getAttribute("data-selling-plan") || "";
      });
    });

    /* ---------- Cart page quantity steppers (auto-submit) ---------- */
    $all("[data-cart-stepper]").forEach(function (st) {
      var input = $("[data-cart-input]", st);
      var form = st.closest("form");
      function commit() { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); }
      var down = $("[data-cart-down]", st), up = $("[data-cart-up]", st);
      if (down) down.addEventListener("click", function () { input.value = Math.max(0, parseInt(input.value, 10) - 1); commit(); });
      if (up) up.addEventListener("click", function () { input.value = parseInt(input.value, 10) + 1; commit(); });
      if (input) input.addEventListener("change", commit);
    });

    /* ---------- Collection filter tabs (client-side, links are canonical) ---------- */
    // Tabs are real <a> links to collections; no JS needed. Kept for active state only.

    /* ---------- Sticky add-to-bag bar reveal on PDP ---------- */
    var sticky = $("[data-sticky-bar]");
    var heroForm = $("[data-product-form]");
    if (sticky && heroForm) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle("is-visible", !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(heroForm);
    }

    /* ---------- Animated clinical bars ---------- */
    $all("[data-clinical]").forEach(function (sec) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            $all("[data-clin-fill]", sec).forEach(function (f) {
              f.style.transform = "scaleX(" + (parseFloat(f.getAttribute("data-pct")) / 100) + ")";
            });
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(sec);
    });
  });
})();
